import { render, staticRenderFns } from "./PublicClients.vue?vue&type=template&id=7ce4ef42&scoped=true"
import script from "./PublicClients.vue?vue&type=script&lang=js"
export * from "./PublicClients.vue?vue&type=script&lang=js"
import style0 from "./PublicClients.vue?vue&type=style&index=0&id=7ce4ef42&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce4ef42",
  null
  
)

export default component.exports